// @ts-strict-ignore
import { Body, Heading } from "components/parts/Typography";
import styled from "styled-components";

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;

  span {
    white-space: break-spaces;
  }

  ul {
    list-style-type: disc;
    margin: 0;
    margin-left: 20px;
    padding: 0;
  }

  ol {
    list-style-type: 1;
    margin: 0;
    margin-left: 20px;
    padding: 0;
  }

  a {
    text-decoration: underline;
    word-break: break-word; /* stopping mobile overflow for long links */
  }

  table {
    text-align: left;
  }
`;

export const SectionHeader = styled(Heading).attrs({ size: "md" })`
  margin: 25px 0 8px 0;
  &:target {
    transform: translateY(-70px);
    span {
      top: 70px;
      position: relative;
    }
  }
`;

export const SectionSubHeader = styled(Heading).attrs({ size: "sm" })`
  margin: 11px 0 4px 0;
  &:target {
    transform: translateY(-70px);
    span {
      top: 70px;
      position: relative;
    }
  }
`;

export const Paragraph = styled(Body).attrs({ size: "md", forwardedAs: "div" })`
  margin: 0;
  padding-bottom: 0;
  overflow-x: scroll;
  max-width: 100%;
  &:target {
    transform: translateY(-70px);
    span {
      top: 70px;
      position: relative;
    }
  }
  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  &::-webkit-scrollbar:horizontal {
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colorPalette.gray["300"]};
    border-radius: 10px;
  }
`;

export const ListItem = styled(Body).attrs({ size: "md", as: "li" })`
  margin: 0 !important;
  padding-bottom: 0 !important;
  div {
    margin: 0 !important;
    padding-bottom: 0 !important;
  }
`;

export const Img = styled.img.attrs((props) => ({
  src: props.src
}))`
  object-fit: contain;
`;

export const HeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0;
  ${({ theme }) => theme.media.desktop`
    margin-top: ${({ theme }) => theme.mobilePadding / 1.2}px;
    margin-bottom: 5px;
  `}
`;

export const SubtitleText = styled(Body).attrs({
  size: "xs",
  color: "secondary"
})`
  margin: 0 0 16px;
  ${({ theme }) => theme.media.desktop`
    margin: 0 0 24px;
  `}
`;

export const FootnoteText = styled(SubtitleText)`
  padding-top: 32px;
  border-top: 1px solid ${({ theme }) => theme.borderColors.primary};
  white-space: pre-line;
`;

export const BottomContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.borderColors.primary};
  margin: 0;
  ${({ theme }) => theme.media.desktop`
    display: none;
  `}
`;

export const TextContainer = styled.div`
  div:first-child {
    margin-top: 16px;
    ${({ theme }) => theme.media.desktop`
      margin-top: 20px;
    `}
  }
  h3:first-child {
    margin-top: 16px;
    ${({ theme }) => theme.media.desktop`
      margin-top: 20px;
    `}
  }
  h2:first-child {
    margin-top: 16px;
    ${({ theme }) => theme.media.desktop`
      margin-top: 20px;
    `}
  }
`;

export const MobileContent = styled.div`
  margin: 0;
  display: flex;
  width: 100%;
  padding-top: 22px;
  ${({ theme }) => theme.media.desktop`
    display: none;
  `}
`;
